import api from "../services/api";

interface IAgentProductivityMonthResponse {
    codeResult: string;
    data: any[];
}

export interface IAgentProductivityMonthParams {
    dataInicial: string;
    dataFinal: string;
    regionalId: string;
    sectorId: string;
    agentId: string;
}
export interface IAgentProductivityMonth {
    gerente: string;
    representante: string;
    quantidade: number;
}


class AgentProductivityMonthRepository {
    public async AgentProductivityMonth({ dataInicial, dataFinal, regionalId, sectorId, agentId}: IAgentProductivityMonthParams): Promise<IAgentProductivityMonth[]> {

        const body = {
            "tables": ["Kit", "Pedido", "Representante", "GerenteSetor"],
            "sql": [
                {
                    "coderesult": "RepresentanteProdu",
                    "query": `SELECT GerenteSetor.nome as Gerente, 
                    Representante.nome as Representante, 
                    COUNT(Kit.id) as Qtd 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    INNER JOIN Representante 
                    ON Representante.id = Pedido.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Pedido.gerenteSetorId 
                    WHERE Kit.tipo = 0 
                    AND Kit.dataEntrega >= '${dataInicial}' 
                    AND Kit.dataEntrega < '${dataFinal}T23:59:59Z'
                    AND Kit.estado = 0 
                    AND Kit.statusKit = 3 
                    ${regionalId.length > 0 ? `AND Pedido.gerenteRegionalId = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND Pedido.gerenteSetorId = '${sectorId}' ` : ""}
                    ${agentId.length > 0 ? `AND Pedido.representanteId = '${agentId}' ` : ""} 
                    GROUP BY GerenteSetor.nome, Representante.nome
                    ORDER BY Qtd DESC`
                }
            ]
        };

        const response = await api.post<IAgentProductivityMonthResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "RepresentanteProdu").map(result => {
            return {
                gerente: result.Gerente,
                representante: result.Representante,
                quantidade: result.Qtd
            }
        });
    }

    GetFromCodeResult(data: IAgentProductivityMonthResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const agentProductivityMonthRepository = new AgentProductivityMonthRepository();
export default agentProductivityMonthRepository;